import {atom} from "jotai";

export const reportesAtom = atom([]);
export const visibleModalCrearReporteAtom = atom(false);
